export const TOKEN = 'token'
export const REFRESH_TOKEN = 'refreshToken'
export const USER_ID = 'userId'
export const USER_NAME = 'userName'

// export const TOKEN_DELAY = 5000
export const TOKEN_DELAY = 13800000
